import {Client} from '../../../graphql/types'

const IB_ID = 10119

export const overrideFor10119 = (accounts: any[], client: Client) => {
  if (!client.metadata) return accounts

  let metadata: any
  try {
    metadata = JSON.parse(client.metadata)
  } catch (err) {
    console.warn('Failed to parse metadata:', client.metadata)
    return accounts
  }

  const remoteIbId = metadata?.ibFollowerData?.remoteIbId

  if (remoteIbId !== IB_ID) return accounts

  return accounts.filter(
    (account) => !['black', 'raw', 'mt5Raw', 'mt5Vip'].includes(account.accountSubtype),
  )
}
